import VaTextInputField from '~/platform/forms-system/src/js/web-component-fields/VaTextInputField';

// Max length and validation regex aligned with VA Profile requirements
const MAX_EMAIL_LENGTH = 254;
const EMAIL_PATTERN =
  '^[a-zA-Z0-9+_.\\-]{1,64}@(?:(?!-)[A-Za-z0-9\\-]{1,63}(?<!-)\\.)+[A-Za-z0-9\\-]{2,63}$';

export const emailFormSchema = {
  type: 'object',
  properties: {
    emailAddress: {
      type: 'string',
      maxLength: MAX_EMAIL_LENGTH,
      pattern: EMAIL_PATTERN,
    },
  },
  required: ['emailAddress'],
};

export const emailUiSchema = {
  emailAddress: {
    'ui:title': 'Email address',
    'ui:autocomplete': 'email',
    'ui:webComponentField': VaTextInputField,
    'ui:errorMessages': {
      required:
        'Enter a valid email address without spaces using this format: email@domain.com',
      pattern:
        'Enter a valid email address without spaces using this format: email@domain.com',
    },
    'ui:options': {
      inputType: 'email',
    },
  },
};

export const emailConvertCleanDataToPayload = value => {
  return { ...value, emailAddress: value.emailAddress.trim() };
};
